// @ vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
const PropTypes = require('prop-types');

// @components
const WizardError = require('components/commons/wizardError/wizardError');

// @utilities
const { recordProcess } = require('utilities/tagging');

//@constants
const {
    PROC_ADD_SHIPPING_ADDRESS,
    PROC_EDIT_SHIPPING_ADDRESS,
    PROC_FAIL,
} = require('utilities/tagging');

class MyProfileEditShippingAddressError extends React.Component {

    componentDidMount() {
        const { immProfileShippingAddress } = this.props;

        let processType = PROC_ADD_SHIPPING_ADDRESS;

        if (immProfileShippingAddress.get('hasShippingAddress')) {
            processType = PROC_EDIT_SHIPPING_ADDRESS;
        }

        recordProcess(processType, PROC_FAIL);
    }

    render() {
        const { immVariables } = this.props;
        const goBackButton = {
            label: (
                <FormattedText
                    value="profileEditShippingAddress-profileEditShippingAddress_successBackButtonText"
                />
            ),
            url: `/myprofile/edit`
        };

        return (
            <WizardError
                errorMessage={formatText('profileEditShippingAddress-profileEditShippingAddress_errorTitle')}
                mainButton={goBackButton}
            >
                <FormattedText
                    injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                    value="profileEditShippingAddress-profileEditShippingAddress_errorSubtitle"
                />
            </WizardError>
        );
    }
}

MyProfileEditShippingAddressError.propTypes = {
    immProfileShippingAddress: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
};

module.exports = MyProfileEditShippingAddressError;
